import PptxGenJS, { Slide } from "pptxgenjs"
import { ReportConfiguration } from "../../configuration"
import { MasterSlide } from "../pptx-configuration/master-slides"
import { Placeholder } from "../pptx-configuration/placeholders"
import { createGlobelSection } from "./dettes-globales"
import { createReellesSection } from "./dettes-réelles"
import { createSimuleesSection } from "./dettes-simulées"
import {createBudgetAnnexes} from "./budget-Annexes"
import { DocumentSection } from "../types"
import { formatTitle } from "../utils"
import * as Model from "../../../../model"
import * as Constants from "../pptx-configuration/constants"


export function checkBudgetSection(configuration: ReportConfiguration): boolean {
    return configuration.budgetAnnexe.budgetsAnnexes
}
export function checkdettesReelles(configuration: ReportConfiguration): boolean {
    return configuration.budgetAnnexe.dettesReelles
}
export function checkdettesSimulées(configuration: ReportConfiguration): boolean {
    return configuration.budgetAnnexe.dettesSimulées
}
export function checkdettesGlobales(configuration: ReportConfiguration): boolean {
    return configuration.budgetAnnexe.dettesGlobales
}

/**
 * Creates slides about retrospective.
 * @param pptx
 * @param configuration
 * @param sectionNumber
 */
export function createBudgetSection(
	pptx: PptxGenJS,
	configuration: ReportConfiguration,
	numbering: number[],
	localAuthority: Model.LocalAuthority,
	scenario: Model.Scenario,
	ppi: Model.Ppi,
	loanDecompositions: Model.LoanDecomposition[],
	budgetData: any,
	childDecomposedLoans:any,
	decomposedLoans:any,
): DocumentSection {
	const hasbudgetAnnexSection = configuration.budgetAnnexe.budgetsAnnexes
	const hasdettesReellesSection = configuration.budgetAnnexe.dettesReelles
	const hasdettesSimuléesSection = configuration.budgetAnnexe.dettesSimulées
	const hasdettesGlobalesSection = configuration.budgetAnnexe.dettesGlobales

	const years = configuration.generalities.years

	if (!(hasbudgetAnnexSection || hasdettesGlobalesSection || hasdettesReellesSection || hasdettesSimuléesSection))
		return { slides: [], title: null }

	const summarySlide = pptx.addNewSlide(MasterSlide.Default)
	const title = formatTitle("Budgets Annexes", numbering)
	summarySlide.addText(title, { placeholder: Placeholder.Title })
	const slides: Slide[] = []
	const subTitles: string[] = []
	

	let subsectionNumber = 0
	let partNumber = 0

	if(hasdettesGlobalesSection || hasdettesReellesSection || hasdettesSimuléesSection){
    if(hasdettesGlobalesSection){
		let checked = "globel"
		const globelSection = createGlobelSection(
			pptx,
			configuration,
			numbering.concat(++partNumber),
			childDecomposedLoans,
			years,
			checked,
			decomposedLoans
		)
		globelSection.slides.forEach(s => slides.push(s))
		subTitles.push(globelSection.title)
	}
	if(hasdettesReellesSection){
		let checked = "reelles"
		const reellesSection = createReellesSection(
			pptx,
			configuration,
			numbering.concat(++partNumber),
			childDecomposedLoans,
			years,
			checked,
			decomposedLoans
		)
		reellesSection.slides.forEach(s => slides.push(s))
		subTitles.push(reellesSection.title)
	}
	if(hasdettesSimuléesSection){
		let checked = "simulées"
		const simuléesSection = createSimuleesSection(
			pptx,
			configuration,
			numbering.concat(++partNumber),
			childDecomposedLoans,
			years,
			checked,
			decomposedLoans
		)
		simuléesSection.slides.forEach(s => slides.push(s))
		subTitles.push(simuléesSection.title)
	}
	}

	if (hasbudgetAnnexSection) {
		const BudgetAnnexes = createBudgetAnnexes(
			pptx,
			configuration,
			numbering.concat(++partNumber),
			localAuthority,
			scenario,
			ppi,
			loanDecompositions,
			years,
			budgetData
		)
		BudgetAnnexes.slides.forEach(s => slides.push(s))
		subTitles.push(BudgetAnnexes.title)

	}

	summarySlide.addText(
		subTitles.map(t => ({ text: t, options: { breakLine: true }})),
		Constants.getTextPlacementOptions
	)



	return { title, slides }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/index.tsx